import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { RequestsTable, PrivateLayout } from '../components';
import { FeatureGuard } from '../components/multi-tenant/FeatureGuard';
import { navigateToServiceRequest } from '../redux';
import { buttonBackgroundSelector } from '../redux/selectors/buttonBackground.selector';

export const RequestsView = () => {
  const dispatch = useDispatch();

  const renderButton = () => {
    const buttonBackgroundClass = useSelector(buttonBackgroundSelector);
    return (
      <FeatureGuard contentKey='service-request.manage'>
        <Button
          variant='secondary'
          size='sm'
          className={`text-nowrap ${buttonBackgroundClass}`}
          onClick={() => dispatch(navigateToServiceRequest())}>
          START A NEW REQUEST
        </Button>
      </FeatureGuard>
    );
  };

  return (
    <PrivateLayout pageTitle='requests' subtoolbarChildren={renderButton()}>
      <RequestsTable enableExternalFilters />
    </PrivateLayout>
  );
};
